import { Component, computed, effect, Input, signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Wallet } from '../../../models/dfs-events.models';
import { DfsService } from '../../../services/dfs.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-withdrawal',
  standalone: true,
  imports: [CommonModule, 
    ReactiveFormsModule, ReactiveFormsModule, 
    MatProgressSpinnerModule, MatFormFieldModule, MatInputModule,
    MatButtonModule
  ],
  templateUrl: './withdrawal.component.html',
  styleUrl: './withdrawal.component.scss'
})
export class WithdrawalComponent {
  @Input() walletId!: string;

  wallet = signal<Wallet | null>(null);
  withdrawalAmount = signal<number>(0);
  canWithdraw = computed(() => {
    if (this.wallet()) {
      const balance = parseFloat(this.wallet()!.balance || '0');
      return balance >= this.wallet()!.minWithdrawalLimit;
    }
    return false;
  });

  withdrawalControl = new FormControl(
    { value: 0, disabled: true },
    [Validators.required, Validators.min(1)]
  );

  isLoading = signal<boolean>(false);
  errorMessage = signal<string>('');


  ngOnInit(): void {
    this.fetchWallet();
  }

  constructor(private walletService: DfsService) {
    effect(() => {
      if (this.canWithdraw()) {
        this.withdrawalControl.enable();
      } else {
        this.withdrawalControl.disable();
      }
    });
  }

  fetchWallet(): void {
    this.isLoading.set(true);
    this.walletService.getWalletSummary().subscribe({
      next: (data) => {
        this.wallet.set(data.data);
        this.isLoading.set(false);
      },
      error: (error) => {
        this.errorMessage.set(error.message);
        this.isLoading.set(false);
      }
    });
  }

  withdraw(): void {
    if (this.withdrawalControl.invalid || !this.wallet()) {
      return;
    }

    const amount = this.withdrawalControl.value ?? 0;
    const balance = parseFloat(this.wallet()?.balance || '0');

    if (amount > balance) {
      this.errorMessage.set('Withdrawal amount cannot exceed wallet balance.');
      return;
    }

    this.isLoading.set(true);
    this.walletService.withdrawFromWallet(amount ?? 0).subscribe({
      next: (response) => {
        this.fetchWallet();
        this.withdrawalControl.reset();
        this.isLoading.set(false);
        this.errorMessage.set('Withdrawal successful!');
      },
      error: (error) => {
        this.errorMessage.set(error.message);
        this.isLoading.set(false);
      }
    });
  }
}
